import AbsComponent from '../../common/components/AbsComponent';
import BasicInfoTempl from './BasicInfoTempl';

/**
 * Sub1 class
 * @category testApp
 */
class BasicInfo extends AbsComponent{
    constructor(_store={}, _el='', _callBack={}){
        super(_store, _el);
        this.callBack = _callBack;
        this.store.getCharacterBasicData(_store.data.config.serverType, _store.data.config.serverId, _store.data.config.characterName, this.render.bind(this));
    }

    render(_jsonData = {}){
        $(this.el).append(BasicInfoTempl.getTempl(_jsonData, this.store.data.config));

      this.callBack();
      this.addEvents();
    }

    addEvents(){
        $(document).ready(function() {
            $(document).on('click', '.character-info-header .btn-character-name', function(e) {
                $(".character-info-header .character-list-layer").addClass('is-show');
                $('.character-dimmed-layer').addClass('is-dimmed');
                return false;
            });
            $(document).on('click', '.btn-close-layer', function(e) {
                $(".character-info-header .character-list-layer").removeClass('is-show');
                $('.character-dimmed-layer').removeClass('is-dimmed');
                return false;
            });
            $('.character-list-layer .loading-wrap').removeClass('is-show');
        });
    }
}

export default BasicInfo;
